import React from 'react';
import { TFunction } from 'react-i18next';
import { Step, Styles } from 'react-joyride';
import { ImgWebp } from '../../ImgWeb';
import { Dots } from './Dots';

export const tourSteps = (t: TFunction): Step[] => {
  return [
    {
      title: t('productTour.menuTitle'),
      target: '.button__burger',
      content: (
        <>
          {t('productTour.menuContent')} <Dots activeItem={1} />
        </>
      ),
      disableBeacon: true,
      placement: 'bottom-end',
    },
    {
      title: t('productTour.serviceCardTitle'),
      target: '.service-card.card.card__extra',
      content: (
        <>
          {t('productTour.serviceCardDescription')} <Dots activeItem={2} />
        </>
      ),
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      title: t('productTour.tutorialTitle'),
      target: '.icon-btn-tour',
      content: (
        <>
          {t('productTour.tutorialDescription')} <Dots activeItem={3} />
        </>
      ),
      disableBeacon: true,
      placement: 'left',
    },
  ];
};

export const tourSkipped = (t: TFunction, fallbackSrc: string): Step[] => {
  return [
    {
      title: t('productTour.reminderTitle'),
      target: '.button__burger',
      content: (
        <>
          {t('productTour.reminderDescription')} <ImgWebp fallback={fallbackSrc} alt="Start learn" className="img" />
        </>
      ),
      disableBeacon: true,
      placement: 'bottom-end',
    },
  ];
};

export const tourStyles: Partial<Styles> = {
  options: {
    width: 430,
    arrowColor: 'var(--color-page-bg)',
    backgroundColor: 'var(--color-page-bg)',
    textColor: 'var(--color-text-icons)',
  },
  buttonClose: {
    width: 32,
    height: 32,
    maxWidth: 14,
    maxHeight: 14,
    padding: 0,
    display: 'grid',
    justifyContent: 'center',
    alignContent: 'center',
    overflow: 'hidden',
    top: 18,
    right: 18,
  },
  tooltipTitle: {
    fontFamily: 'Roboto',
    fontSize: 22,
    fontWeight: 500,
    lineHeight: '27px',
  },
  tooltipContent: {
    fontSize: 16,
    fontWeight: 400,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
  },
  tooltipFooter: {
    gap: 15,
    justifyContent: 'center',
  },
  tooltipFooterSpacer: {
    display: 'none',
  },
  tooltip: {
    padding: 30,
    borderRadius: 8,
  },
  buttonBack: {
    margin: 0,
    flexGrow: 1,
    width: '100%',
    backgroundColor: 'inherit',
    fontWeight: 700,
    fontSize: 16,
    padding: 15,
    lineHeight: '19px',
    borderRadius: 10,
    color: 'var(--color-accent)',
    textTransform: 'unset',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'var(--color-accent)',
    transition: '0.2s ease',
  },
  buttonNext: {
    margin: 0,
    flexGrow: 1,
    width: '100%',
    backgroundColor: 'var(--color-accent)',
    fontWeight: 700,
    fontSize: 16,
    padding: 15,
    lineHeight: '19px',
    borderRadius: 10,
    color: 'var(--color-button-text)',
    textTransform: 'unset',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'transparent',
    transition: '0.2s ease',
  },
  spotlight: {
    borderRadius: 10,
  },
};
